import React, { useEffect, useState } from 'react';
// import { shallowEqual, useDispatch, useSelector } from 'react-redux';
// import * as actions from '../../../_redux/queues/queuesActions';
import { v4 as uuidv4 } from 'uuid';
import asyncBatch from 'async-batch';
import { useRecoilCallback, useSetRecoilState } from 'recoil';
import { sleep } from '../queue-edit-dialog/QueueEditForm';
import {
  methodNameEnum,
  refetchToggle,
} from '../../../../../recoil/selectors/makePHPRequest';
import { Logger } from '../../../../../common/Logger';
import { GridRowData } from '@mui/x-data-grid';
import { AxiosResponse } from 'axios';
import { ModalWithStyles } from '../../../../components/modals/ModalWithStyles';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../../../services/rest/makeAPIRequest';

interface IQueuesDeleteDialog {
  selected: GridRowData[];
  setSelected: React.Dispatch<React.SetStateAction<GridRowData[]>>;
  show: boolean;
  onHide: () => void;
}

export function QueuesDeleteDialog({
  selected,
  setSelected,
  show,
  onHide,
}: IQueuesDeleteDialog) {
  const setRefetchToggleForBusinessQueues = useSetRecoilState(
    refetchToggle(methodNameEnum.GET_BUSINESS_QUEUES)
  );

  const [fetchState, setFetchState] = useState({
    state: 'hasValue',
    message: '',
  });
  const deleteQueues = useRecoilCallback(({ snapshot }) => async () => {
    // if id not populated then create new queue
    const deleteResponses: AxiosResponse<any>[] = [];
    // show loading UI
    setFetchState({
      state: 'loading',
      message: '',
    });
    let errorMessage: any;
    // server request for update queues toggles
    // run as async since synchronous atom updates will only trigger one reload
    await asyncBatch(
      selected,
      async ({ id: queueid }: { id: string }) => {
        // stop if error occurred
        const data = {
          call: methodNameEnum.DELETE_QUEUE,
          queueid,
          transactionId: uuidv4(),
        };
        if (!errorMessage) {
          const response = await snapshot.getPromise(
            // makePHPRequest({
            //   methodName: methodNameEnum.DELETE_QUEUE,
            //   payloadJsonString: JSON.stringify({
            //     queueid,
            //   }),
            // transactionId: uuidv4(), // generate uuid to break selector cache
            // })
            makeAPIRequest({
              endpoint: endpointEnum.DELETE_QUEUE,
              payloadJsonString: JSON.stringify(data),
            })
            // generate uuid to break selector cache
          );
          deleteResponses.push(response);
          errorMessage = response?.data?.error;
          await sleep(100); // pause between calls to reduce load on database
        }
      },
      1 // one at a time
    );

    // clear selection and close modal on success
    if (!errorMessage) {
      // stop loading UI
      setFetchState({
        state: 'hasValue',
        message: '',
      });

      // clear selection
      setSelected([]);

      // refetch business queues
      setRefetchToggleForBusinessQueues({});

      // closing delete modal
      onHide();

      Logger.trace(
        {
          message: `Success deleteQueue[${selected.length}]`,
          deleteResponses,
        },
        'deleteQueues'
      );
    } else {
      // stop loading UI
      // set error message
      setFetchState({
        state: 'hasError',
        message: errorMessage,
      });

      // log error and stop loading on failed
      Logger.error(
        {
          message: `Failed deleteQueue[${selected.length}]`,
          errorMessage,
          deleteResponses,
        },
        'deleteQueues'
      );
    }
  });

  // if queues weren't selected we should close modal
  // for refreshing the page
  useEffect(() => {
    if (!selected || selected.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <ModalWithStyles
      onSubmit={deleteQueues}
      title="Delete Queue(s)"
      aria-labelledby="example-modal-sizes-title-md"
      show={show}
      onHide={onHide}
      isSubmitting={fetchState.state === 'loading'}
      isLoading={fetchState.state === 'loading'}
      size="xs"
      deleteDialog={true}
    >
      <>
        <p>
          You are about to delete {selected.length} Queue(s), this procedure is
          not reversible.
        </p>
        <p>Do you want to proceed?</p>
      </>
      {fetchState.state === 'hasError' && <span>Error deleting queues...</span>}
    </ModalWithStyles>
  );
}
